import React from 'react'
import ResultTable from './Result'
import { Box } from '@mui/material'
const allocatedCRM = () => {
  return (
<Box>
<ResultTable/>
</Box>
  )
}

export default allocatedCRM